"use client";

import { transcriptSchema } from "../../../lib/types/schema/transcriptSchema";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyTranscript } from "./keyTranscript";

export type UseRequestTranscriptProps = UseRequestQueryProps & {
  id: number;
};

export const useRequestTranscript = ({
  id,
  ...props
}: UseRequestTranscriptProps) => ({
  query: useRequestQuery({
    enabled: typeof id === "number",
    ...props,
    queryFnRequestProps: {
      schema: transcriptSchema,
      urlBackendPath: `/audio/${id}/transcript`,
      next: {
        revalidate: 3600,
      },
      headers: {
        "X-Hallow-Version": "2049",
      },
    },
    queryKey: keyTranscript({ id }),
  }),
});
